import { useNavigate } from 'react-router-dom';
import NovaSolicitacaoContent from './NovaSolicitacaoContent';
import type { NovaSolicitacaoPageProps } from './novaSolicitacaoPage.types';

/**
 * Wrapper fino da rota `/si/nova` — preserva o deep-link direto pra criação de
 * Solicitação. Todo o formulário/lógica vive em NovaSolicitacaoContent, reaproveitado
 * também pelo drawer aberto a partir da lista (ver NovaSolicitacaoDrawer).
 */
export default function NovaSolicitacaoPage({ className }: NovaSolicitacaoPageProps) {
  const navigate = useNavigate();

  return (
    <NovaSolicitacaoContent
      className={className}
      onCriada={(solicitacaoId) =>
        navigate(`/si/solicitacoes/${solicitacaoId}`, { state: { forcarVisaoSolicitante: true } })
      }
      onCancelar={() => navigate('/si')}
    />
  );
}
